(function (app, ng) {

    var onBehalfOfCookieName = "X-On-Behalf-Of";

    app.provider("permissionService",
        [
            function () {
                this.$get = [
                    "_", "featureToggleService", "$cookies", function (_, featureToggleService, $cookies) {
                        return {
                            setPermissions: setPermissions,
                            getPermissions: getPermissions,
                            setOnBehalfOfUserId: setOnBehalfOfUserId,
                            getOnBehalfOfUserId: getOnBehalfOfUserId,
                            migrateOnBehalfOfStorage: migrateOnBehalfOfStorage,
                            setUserDelegateId: setUserDelegateId,
                            getUserDelegateId: getUserDelegateId,
                            hasAllPermissions: hasAllPermissions,
                            hasOnePermission: hasOnePermission,
                            removeStoredPermissions: removeStoredPermissions,
                            removeStoredOnBehalfOfUserId: removeStoredOnBehalfOfUserId,
                            setOptOutMasterAdvisorAgreement: setOptOutMasterAdvisorAgreement,
                            getOptOutMasterAdvisorAgreement: getOptOutMasterAdvisorAgreement,
                            emailDomainAllowed: emailDomainAllowed,
                        };

                        function setPermissions(permissions) {
                            localStorage.setItem("Auth.Permissions", JSON.stringify(permissions));
                        }

                        function getPermissions() {
                            return JSON.parse(localStorage.getItem("Auth.Permissions"));
                        }

                        function setOnBehalfOfUserId(userId) {
                            // save in both places for now
                            // TODO: remove localstorage here and in getOnBehalfOfUserId after a week or so
                            // using cookies here instead of localstorage so that requests for new tabs and iframes will include the cookie automaticalls
                            $cookies.put(onBehalfOfCookieName, userId, {samesite:"lax"});
                            localStorage.setItem("Auth.OnBehalfOfUserId", userId);
                        }

                        function getOnBehalfOfUserId() {
                            // read from either place for now
                            return localStorage.getItem("Auth.OnBehalfOfUserId") || $cookies.get(onBehalfOfCookieName);
                        }

                        function migrateOnBehalfOfStorage() {
                            // convert from old localstorage to new cookie storage
                            var userId = localStorage.getItem("Auth.OnBehalfOfUserId");
                            if (userId && !$cookies.get(onBehalfOfCookieName)) {
                                setOnBehalfOfUserId(userId);
                            }
                        }

                        function setUserDelegateId(userDelegateId) {
                            localStorage.setItem("Auth.UserDelegateId", userDelegateId);
                        }

                        function getUserDelegateId() {
                            return localStorage.getItem("Auth.UserDelegateId");
                        }

                        function hasAllPermissions(checkPermissions) {

                            var current = _.sortBy(getPermissions(), function (row) { return row.Effect; });
                            var permissions = checkPermissions.split("|");
                            var allow = false;
                            var breakRepeat = false; 
                            ng.forEach(permissions, function (val) {
                                var resource = val.split(":")[0];
                                var action = val.split(":")[1];
                                var exists = false;
                               
                                if (breakRepeat)
                                {
                                    return false;
                                }
                                ng.forEach(current, function (permission) {

                                    ng.forEach(permission.Actions, function (a) {
                                        if (a.AllowAll === "*" && permission.Effect === "ALLOW") {
                                            allow = true;
                                            exists = true;
                                            return true;
                                        }
                                        if (a.AllowAll === "*" && permission.Effect === "DENY") {
                                            allow = false;
                                            exists = true;
                                            return allow;
                                        }
                                        if (a.Resource === resource &&
                                            a.Action === action) {
                                            if (permission.Effect === "ALLOW")
                                                allow = true;
                                            if (permission.Effect === "DENY") {
                                                allow = false;
                                                return allow; //go ahead and return allow as false, don't need to check any more permissions because a deny was found
                                            }
                                            exists = true;
                                        }
                                    });
                                });

                                if (!exists) {
                                    allow = false;
                                    breakRepeat = true;
                                    return allow;
                                }
                            });

                            return allow;

                            //var currentPermissions = _.sortBy(getPermissions(), function (row) { return row.Effect; });
                            //var allowedPermissionNames = [];
                            //var deniedPermissionNames = [];
                            //ng.forEach(currentPermissions, function (cp) {

                            //    if (cp.Effect === "ALLOW") {
                            //        allowedPermissionNames.push(cp.Name);
                            //    }
                            //    if (cp.Effect === "DENY") {
                            //        deniedPermissionNames.push(cp.Name);
                            //    }
                            //});

                            //allowedPermissionNames = _.uniq(_.difference(allowedPermissionNames, deniedPermissionNames));
                            //var allowedPermissionsArray = [];
                            //ng.forEach(currentPermissions, function (cp) {

                            //    ng.forEach(allowedPermissionNames, function (ap) {
                            //        if (ap === cp.Name) {
                            //            allowedPermissionsArray.push(cp);
                            //        }
                            //    });
                            //});

                            //var allow = null;
                            //var uiPermissions = checkPermissions.split("|");
                            //ng.forEach(uiPermissions, function (val) {
                            //    //if allow is ever false, user does not have at least one of the permissions, so return allow = false
                            //    if (allow === null || allow === true)
                            //        allow = false;
                            //        var resource = val.split(":")[0];
                            //        var action = val.split(":")[1];

                            //        ng.forEach(allowedPermissionsArray, function (permission) {

                            //            ng.forEach(permission.Actions, function (a) {

                            //                if (a.Resource === resource && a.Action === action) {                                                                                         
                            //                    allow = true;
                            //                }
                            //            });
                            //        }); 

                            //});

                            //return allow;
                        }

                        function hasOnePermission(checkPermissions, inverted) {
                            //var current = getPermissions();
                            var current = _.sortBy(getPermissions(), function (row) { return row.Effect; });
                            var permissions = checkPermissions.split("|");
                            var allow = undefined;
                            var obj = {};

                            ng.forEach(permissions, function (val) {
                                //if allow is ever true after running through all current permissions, user has at least one so can return
                                //if (allow)
                                //    return allow;
                                var resource = val.split(":")[0];
                                var action = val.split(":")[1];
                                
                                if (obj[resource + ":" + action] !== false) {
                                    ng.forEach(current,
                                        function(permission) {
                                            ng.forEach(permission.Actions,
                                                function(a) {
                                                    if (a.AllowAll === "*" && permission.Effect === "ALLOW") {
                                                        allow = inverted ? false : true;
                                                        return allow;
                                                    }
                                                    if (a.AllowAll === "*" && permission.Effect === "DENY") {
                                                        allow = inverted ? true : false;
                                                        return inverted ? allow : !allow;
                                                    }

                                                    if (a.Resource === resource &&
                                                        a.Action === action) {
                                                        if (permission.Effect === "ALLOW") {
                                                            obj[resource + ":" + action] = true;
                                                        }
                                                        if (permission.Effect === "DENY") {
                                                            obj[resource + ":" + action] = false;
                                                        }
                                                    }
                                                });
                                        });
                                }
                            });
                            if (allow !== undefined)
                                return allow;
                            allow = _.find(Object.keys(obj), function (row) { return obj[row]; });
                            return allow;
                        }

                        //function hasOnePermission(checkPermissions) {

                        //    var currentPermissions = _.sortBy(getPermissions(), function (row) { return row.Effect; });                                                       
                        //    var allowedPermissionNames = [];
                        //    var deniedPermissionNames = [];
                        //    ng.forEach(currentPermissions, function (cp) {

                        //        if (cp.Effect === "ALLOW") {
                        //            allowedPermissionNames.push(cp.Name);
                        //        }
                        //        if (cp.Effect === "DENY") {
                        //            deniedPermissionNames.push(cp.Name);
                        //        }
                        //    });

                        //    allowedPermissionNames = _.uniq(_.difference(allowedPermissionNames, deniedPermissionNames));
                        //    var allowedPermissionsArray = [];
                        //    ng.forEach(currentPermissions, function (cp) {

                        //        ng.forEach(allowedPermissionNames, function (ap) {
                        //            if (ap === cp.Name) {
                        //                allowedPermissionsArray.push(cp);
                        //            }
                        //        });
                        //    });

                        //    var allow = false;
                        //    var uiPermissions = checkPermissions.split("|");
                        //    ng.forEach(uiPermissions, function (val) {
                        //        //if allow is ever true, user has at least one permissions, so return allow = true;
                        //        if (allow === false) {

                        //            var resource = val.split(":")[0];
                        //            var action = val.split(":")[1];

                        //            ng.forEach(allowedPermissionsArray, function (permission) {

                        //                ng.forEach(permission.Actions, function (a) {

                        //                    if (a.Resource === resource && a.Action === action) {
                        //                        allow = true;
                        //                    }
                        //                });
                        //            });
                        //        }
                        //    });
                        //    return allow;
                        //}

                        function setOptOutMasterAdvisorAgreement() {
                            localStorage.setItem("Agreement-Opt-Out", new Date());
                        }

                        function getOptOutMasterAdvisorAgreement() {
                            return localStorage.getItem("Agreement-Opt-Out");
                        }

                        function removeStoredPermissions() {
                            localStorage.removeItem("Auth.Permissions");
                            localStorage.removeItem("Agreement-Opt-Out");
                        }

                        function removeStoredOnBehalfOfUserId() {
                            $cookies.remove(onBehalfOfCookieName);
                            localStorage.removeItem("Auth.OnBehalfOfUserId");
                            localStorage.removeItem("Auth.UserDelegateId");
                        }

                        function emailDomainAllowed(email) {
                            return /@simonmarkets.com\s*$/.test(email.toLowerCase()) || 'figdevteam@figmarketing.com' === email.toLowerCase();
                        }
                    }
                ];
            }
        ]);
})(window.app, window.angular); // jshint ignore:line